module.exports = __webpack_public_path__ + "assets/9221dbc8b6c0133fc5ce9ea53c3523b5.mp3";